import React from "react";

import { Button } from "@king-ict/eupisi-ui/components";
import { useTranslation } from "react-i18next";

interface ActionButtonProps {
  canApply: boolean;
  handleApply: () => void;
  handleRefresh: () => void;
  isLoading: boolean;
  isHidden?: boolean; // If the user doesn't have an OIB
}

interface IProps {
  title: string;
  subtitle?: string;
  actionButton?: ActionButtonProps;
  className?: string;
  children?: React.ReactNode;
}

export const SectionHeader = ({
  title,
  subtitle,
  actionButton,
  className,
  children,
}: IProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={`d-flex align-items-center justify-content-between mb-3 ${
        className ?? ""
      }`}
    >
      <div className="d-flex align-items-center">
        <span className="fw-bold">{title}</span>
        {subtitle && (
          <span className="ms-2 ml-2 text-muted" style={{ fontWeight: 400 }}>
            ({subtitle})
          </span>
        )}
      </div>
      {!!actionButton && !actionButton.isHidden && (
        <div>
          {actionButton.canApply ? (
            <Button size="sm" onClick={actionButton.handleApply} outline>
              {t("common.apply")}
            </Button>
          ) : (
            <Button
              size="sm"
              onClick={actionButton.handleRefresh}
              outline
              disabled={actionButton.isLoading}
            >
              {actionButton.isLoading
                ? t("common.loading")
                : t("request.refresh")}
            </Button>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
